<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="goBack" color="primary" type="border"
              >Back</vs-button
            > </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>Unmatched Contacts From {{campaignDescription["campaign_name"]}}</h5>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>

      <!-- AgGrid Table -->
      <DataGrid :context="'unassociatedContactsWithAccountssGrid'" 
        ref="unassociatedContactsWithAccountssGrid"
        :columnDefs="columnDefs"
        :rowData="unassociatedContactsWithAccounts"
        :dataSource="dataSource"
      >
      </DataGrid>
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription:{},
    unassociatedContactsWithAccounts: [],
    columnDefs: [
    ]
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  watch: {
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    getColumnsFromCSVTable() {
    var self = this;
    self.$store
      .dispatch(
        "campaignsManagement/getAllContactSelectedCampaignColumns",
        self.$route.params.campaignId
      )
      .then(res => {
        if (res.data.status == "success") {
            let selected_columns = res.data.data;


            selected_columns = selected_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
            });

            selected_columns.forEach(function(ele) {

          
              ele.headerName = ele.name;

              ele.field = '_' + ele.id.replaceAll("-", "_");

              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.columnDefs = selected_columns

      
        }

      

      })
      .catch(err => {
        console.log(err);
      });
  },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          const campaignId = self.$route.params.campaignId;
          self.$store
            .dispatch("campaignsManagement/fetchCampaign", campaignId)
            .then(res => {
              self.campaignDescription = res.data;

              params.request.table_name = 'temp_' + self.campaignDescription["id"].replaceAll("-", "_") + "_contacts";

              self.$store
                .dispatch(
                  "contactsManagement/unassociatedContactsWithAccounts",
                  params.request
                )
                .then(function(response) {
                  let response_data = response.rows;

                  response_data.forEach(function(element,index) {
                    element.unique_id = index;
                  });


                  if (response_data.length != 0) {
                    self.$refs.unassociatedContactsWithAccountssGrid.gridApi.hideOverlay();

                    params.success({ rowData: response.rows , rowCount: response.lastRow })
                  } else {
                    self.$refs.unassociatedContactsWithAccountssGrid.gridApi.showNoRowsOverlay();
                    return params.success({ rowData: [] })
                  }
                })
            
                .catch(err => {
                  console.error(err);
                });
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    }
  },
  mounted() {
    this.getDataSource();
    this.getColumnsFromCSVTable();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsContacts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
